import React from 'react';
import { TextContent, Text, TextVariants } from '@patternfly/react-core';
import ComponentPropTypes from './ComponentPropTypes';

const DisplayTextComponent = ({ model, value }) => {

  const renderPlain = () => {
    return (
      <TextContent>
        <Text id={model.path} component={model?.properties?.textVariant ?? TextVariants.p}>
          { value }
        </Text>
      </TextContent>
    );
  };

  return (
    <>
      <TextContent>
        { (model?.properties?.render) ? model?.properties?.render?.(value) : renderPlain() }
      </TextContent>
    </>
  );
};

DisplayTextComponent.propTypes = ComponentPropTypes;

export default React.memo(DisplayTextComponent);
